export * from "./asset";
export * from "./confirmation";
export * from "./device";
export * from "./playlist";
export * from "./playlistV2";
export * from "./channel";
export * from "./profile";
export * from "./ticker";
export * from "./login";
export * from "./fetchAll";
export * from "./webAssetTemplate";
export * from "./ui";
export * from "./notification";
export * from "./user";
export * from "./campaign";
export * from "./tagActions";
export * from "./user_reports";
export { uploadAsset, downloadReport, saveRegionFile } from "./remote";

function refetchResource(resource) { }



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/actions/index.js